/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenameTreatmentPlanFileDto
 */
export interface RenameTreatmentPlanFileDto {
    /**
     * The file type to rename
     * @type {string}
     * @memberof RenameTreatmentPlanFileDto
     */
    fileType: RenameTreatmentPlanFileDtoFileTypeEnum;
    /**
     * New custom name for the file
     * @type {string}
     * @memberof RenameTreatmentPlanFileDto
     */
    customName: string;
}


/**
 * @export
 */
export const RenameTreatmentPlanFileDtoFileTypeEnum = {
    Txt: 'txt',
    Canvas: 'canvas',
    Audio: 'audio',
    PdfReport: 'pdfReport'
} as const;
export type RenameTreatmentPlanFileDtoFileTypeEnum = typeof RenameTreatmentPlanFileDtoFileTypeEnum[keyof typeof RenameTreatmentPlanFileDtoFileTypeEnum];


/**
 * Check if a given object implements the RenameTreatmentPlanFileDto interface.
 */
export function instanceOfRenameTreatmentPlanFileDto(value: object): value is RenameTreatmentPlanFileDto {
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('customName' in value) || value['customName'] === undefined) return false;
    return true;
}

export function RenameTreatmentPlanFileDtoFromJSON(json: any): RenameTreatmentPlanFileDto {
    return RenameTreatmentPlanFileDtoFromJSONTyped(json, false);
}

export function RenameTreatmentPlanFileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenameTreatmentPlanFileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fileType': json['fileType'],
        'customName': json['customName'],
    };
}

export function RenameTreatmentPlanFileDtoToJSON(json: any): RenameTreatmentPlanFileDto {
    return RenameTreatmentPlanFileDtoToJSONTyped(json, false);
}

export function RenameTreatmentPlanFileDtoToJSONTyped(value?: RenameTreatmentPlanFileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileType': value['fileType'],
        'customName': value['customName'],
    };
}

